var nav = document.getElementById("nav"),
burger = document.getElementById("burger"),
links = document.getElementById("nav-links"),
totop = document.getElementById("totop");
window.addEventListener(
"scroll",
function () {
  var y = window.scrollY;
  nav && nav.classList.toggle("is-pinned", y > 40);
  totop && totop.classList.toggle("is-on", y > 600);
},
{ passive: true },
);
burger?.addEventListener("click", function () {
  var open = links?.classList.toggle("is-open");
  burger?.classList.toggle("is-open", open);
});
document.querySelectorAll(".nav-links a").forEach(function (a) {
a.addEventListener("click", function () {
  links?.classList.remove("is-open");
  burger?.classList.remove("is-open");
});
});